import {
  CreditBookmark,
  SelectedInstitution,
  isCreditBookmark,
  isSelectedInstitution,
} from "./types";

import store from "store";

const SELECTED_INSTITUTION_KEY = "selected-source-institution";
const RECENT_INSTITUTIONS_KEY = "recent-institution-ids";
const CREDIT_BOOKMARKS_KEY = "credit-bookmarks";

export const setLocalStorageSelectedInstitution = (
  institution: SelectedInstitution | {},
) => {
  store.set(SELECTED_INSTITUTION_KEY, institution);
};

export const getLocalStorageSelectedInstitution = ():
  | SelectedInstitution
  | {} => {
  const contents = store.get(SELECTED_INSTITUTION_KEY);
  if (contents && isSelectedInstitution(contents)) {
    return contents;
  } else {
    // console.info("Clear localStorage", SELECTED_INSTITUTION_KEY);
    setLocalStorageSelectedInstitution({});
    return {};
  }
};

const isStringArray = (input: any): boolean => {
  return Array.isArray(input) && input.every((i) => typeof i === "string");
};

export const setLocalStorageRecentInstitutionIds = (ids: string[]) => {
  store.set(RECENT_INSTITUTIONS_KEY, ids);
};

export const getLocalStorageRecentInstitutionIds = () => {
  const contents = store.get(RECENT_INSTITUTIONS_KEY);
  if (isStringArray(contents)) {
    return contents;
  } else {
    // console.info("Clear localStorage", RECENT_INSTITUTIONS_KEY);
    setLocalStorageRecentInstitutionIds([]);
    return [];
  }
};

const isCreditBookmarkArray = (input: any): boolean => {
  return Array.isArray(input) && input.every((i) => isCreditBookmark(i));
};
export const setLocalStorageCreditBookmarks = (
  creditBookmarks: CreditBookmark[],
) => {
  store.set(CREDIT_BOOKMARKS_KEY, creditBookmarks);
};
export const getLocalStorageCreditBookmarks = (): CreditBookmark[] => {
  const contents = store.get(CREDIT_BOOKMARKS_KEY);
  if (Array.isArray(contents)) {
  } else {
  }
  if (isCreditBookmarkArray(contents)) {
    return contents;
  } else {
    // console.info("Clear localStorage", CREDIT_BOOKMARKS_KEY);
    setLocalStorageCreditBookmarks([]);
    return [];
  }
};

// const resolveStorageKey = (key) => {
//   return `${process.env.IMPLEMENTATION}_${key}`;
// };
